import Picklist from './Picklist';

export default {
  picklist: Picklist,
};
